export enum MarkerTypeClassName {
  BASE = 'mu-map-marker ',
  MARKER = 'mu-map-marker',
  DOT = 'mu-map-dot',
  LOADING = 'mu-map-loading',
  SHADOW = 'mu-map-shadow',
}
